import { CouponGenqlSelection } from "@/gql/gen";

export const CouponFields: CouponGenqlSelection = {
    ID: true,
    NAME: true,
    COUPON: true,
    PRODUCT_ID: true,
}
